import { Nullable } from '@/utils/types';
import { formatNumber } from '@/utils/filters';

export const formatToSF = (value: Nullable<number>): string => {
  return formatNumber(value) ? `${formatNumber(value)} SF` : '';
}
